"use client"

import { useEffect, useState } from "react"

import { ReducedProductData } from "@/lib/storefront/product/product"
import { trackGTMAndFF } from "@/lib/tracking/tracking-helper"

/*The purpose of this */
export default function FFProductClickTrackingClient(props: {
  trackingList?: string
  productData: ReducedProductData
  position: number
  page?: number
  pageSize?: number
  searchTerm?: string
  campaignId?: string
  trackingMarker: string
}) {
  const [tracked, setTracked] = useState(false)

/*
  const searchParams = useSearchParams()
*/

  useEffect(() => {
    function trackingHandler(event: Event) {
      if (
        event.target instanceof Element &&
        event.target.closest("[data-skip-product-click-tracking]")
      ) {
        return
      }

      trackGTMAndFF(props, /*searchParams*/)
      setTracked(true)
    }

    if (props.trackingList !== undefined) {
      if (!tracked) {
        const element = document.querySelector('[data-tracking-marker="' + props.trackingMarker + '"]')
        if (element) {
          element.addEventListener("click", trackingHandler)
        }
      }
    }
    return () => {
      const element = document.querySelector('[data-tracking-marker="' + props.trackingMarker + '"]')
      if (element) {
        element.removeEventListener("click", trackingHandler)
      }
    }
  }, [props, props.page, props.pageSize, props.position, props.productData, props.trackingList, props.trackingMarker, tracked])

  return (
    <>
      <span className={"prdclk hidden"}>{props.trackingMarker}</span>
    </>
  )
}
